/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimeslotPickerInMeetingRequests from './TimeslotPickerInMeetingRequests.vue';

const __vue_script__ = {
    name: 'TimeslotPickerOverallAvailability',
    extends: TimeslotPickerInMeetingRequests,

    data() {
        return {
            skipCreatedHook: true,
            participantIds: [],
            scrollTimeout: null,
        };
    },

    computed: {
        valueAsUnixTs() {
            return this.value ? this.$utils.time.dateToUnix(this.value) : null;
        }
    },

    async mounted() {
        this.participantIds = (this.$attrs.model?.participants || []).map(d => d._id);

        const duration = Number(this.$attrs.model?.duration);
        if (duration && Number.isInteger(duration)) this.duration = duration;

        await this.getSlots();

        this.$nextTick(async () => {
            this.timeslots = await this.blockRepresentativeBusySlots(this.timeslots);
            this.updateVisibleSlotsRoomAvailability();
        });
    },

    methods: {
        async getSlots() {
            if (!this.participantIds.length) return;
            try {
                const data = await this.$services.meetings.getOverallAvailabilitySlots(
                    this.event._id,
                    this.participantIds,
                    this.duration,
                );

                this.timeslots = data.proposedSlots.map(this.formatSlot);
            } catch (err) {
                console.error('[TimeslotPickerOverallAvailability] getSlots failed', err);
            }
        },

        onScroll() {
            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout);
            }
            this.scrollTimeout = setTimeout(() => {
                this.updateVisibleSlotsRoomAvailability();
            }, 150);
        },

        updateVisibleSlotsRoomAvailability() {
            const container = this.$refs.scrollContainer;
            if (!container || !this.timeslots.length) {
                return;
            }

            const firstSlot = container.querySelector('.timeslot');
            if (!firstSlot) {
                return;
            }

            const slotWidth = firstSlot.offsetWidth;
            const gap = Number.parseFloat(getComputedStyle(container).gap) || 0;
            const totalSlotWidth = slotWidth + gap;

            const startIdx = Math.floor(container.scrollLeft / totalSlotWidth);
            const visibleCount = Math.ceil(container.clientWidth / totalSlotWidth) + 1;
            const endIdx = Math.min(startIdx + visibleCount, this.timeslots.length);

            const visibleSlots = this.timeslots.slice(Math.max(startIdx - 1, 0), endIdx + 1);

            const slotsNeedingUpdate = visibleSlots.filter(
                slot => slot.availableRooms === 0 && !slot._roomsFetching
            );

            if (slotsNeedingUpdate.length > 0) {
                this.addRoomAvailability(slotsNeedingUpdate);
            }
        },

        /** @param {{ start: number, participantIds: string[] }} slot */
        formatSlot({ start, participantIds }) {
            return {
                start,
                startDate: this.$utils.time.tsToFormat(start, 'll', this.event.timezone),
                startTime: this.$utils.time.tsToFormat(start, 'LT', this.event.timezone),
                availableRooms: 0,
                participantCount: participantIds.length,
                _roomsFetching: false,
            };
        },

        onTimeSlotSelected(timeslot) {
            if (this.isReadOnly || !timeslot) {
                return;
            }

            this.$emit('input', this.$utils.time.unixToDate(timeslot.start).toISOString());
        },

        async addRoomAvailability(timeslots) {
            return Promise.all(timeslots.map(async (timeslot) => {
                if (timeslot._roomsFetching) return timeslot;

                timeslot._roomsFetching = true;
                try {
                    timeslot.availableRooms = await this.getRoomOptions(timeslot);
                } catch (e) {
                    console.error('[TimeSlotPicker] Failed to get room options for timeslot', timeslot, e);
                } finally {
                    timeslot._roomsFetching = false;
                }
                return timeslot;
            }));
        },

        async getRoomOptions(timeslot) {
            const { availableRooms } = await this.$services.appScripts.callAppScript(
                this.event._id, 'actions/check-location-availability',
                {
                    timestamp: this.$utils.time.dateToUnix(timeslot.start) * 1000,
                    duration: Number.parseInt(this.$attrs.model.duration, 10),
                    capacity: this.$attrs.model.participants.length + 1,
                }
            );
            return availableRooms.length ?? 0;
        }
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      attrs: {
        label: _vm.label,
        uid: "meeting-request-timeslots#" + _vm.$attrs.model._id,
        "hint-after-label": true,
        hint: _vm.$t("meetings.requests.timeslots.hint"),
      },
    },
    [
      _c("div", { staticClass: "meeting-request-timeslot-picker" }, [
        _vm.timeslots.length
          ? _c(
              "div",
              {
                ref: "scrollContainer",
                staticClass: "timeslots timeslots-scroll-container",
                on: { scroll: _vm.onScroll },
              },
              _vm._l(_vm.timeslots, function (timeslot, idx) {
                return _c(
                  "div",
                  {
                    key: timeslot.start,
                    staticClass: "timeslot",
                    class: {
                      selected: _vm.valueAsUnixTs === timeslot.start,
                      disabled: _vm.isReadOnly,
                    },
                    attrs: { id: "slot-" + idx },
                    on: {
                      click: function ($event) {
                        return _vm.onTimeSlotSelected(timeslot)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "top-section" }, [
                      _c("div", { staticClass: "date" }, [
                        _vm._v(_vm._s(timeslot.startDate)),
                      ]),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(timeslot.startTime)),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "participants",
                          class: {
                            success:
                              timeslot.participantCount ===
                              _vm.participantIds.length,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("meetings.requests.timeslots.available")
                            ) +
                              "\n" +
                              _vm._s(" ")
                          ),
                          _c("span", { staticClass: "count" }, [
                            _vm._v(
                              _vm._s(timeslot.participantCount) +
                                "/" +
                                _vm._s(_vm.participantIds.length)
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "rooms" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$tc(
                            "meetings.requests.timeslots.available-rooms",
                            timeslot.availableRooms,
                            [timeslot.availableRooms]
                          )
                        )
                      ),
                    ]),
                    !_vm.isReadOnly && timeslot.isRangeOverlap
                      ? _c("div", { staticClass: "note-section" }, [
                          _c("div", { staticClass: "error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "meetings.requests.timeslots.already-booked"
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "empty-state" }, [
              _c("p", [
                _vm._v(_vm._s(_vm.$t("meetings.requests.timeslots.empty"))),
              ]),
            ]),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/TimeslotPickerOverallAvailability.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__